<title>{{ contactUs.htmlTitle }}</title>
<app-banner [banner]="contactUs.banner"></app-banner>
<app-support-page-outage-banner-section [outageBanners]="contactUs.outageBanners"></app-support-page-outage-banner-section>
<div class="container mt-3">
  <h3>
    <u>{{ contactUs.contactUsTitle }}</u>
  </h3>
  <div class="container">
    <div *ngIf="contactUs.defaultSelectedCountry" class="dropdown">
      <select class="dropdown-select" [(ngModel)]="contactUs.defaultSelectedCountry" (change)="updateSelectedValue($event)">
        <option *ngFor="let section of contactUs.sections" [value]="section.group">{{ section.group }}</option>
      </select>
    </div>
    <br />
    <div class="card">
      <img *ngIf="contactUs.cardImage" class="card-img-top" [src]="contactUs.cardImage" alt="Card image cap" />
      <div *ngIf="contactUs.defaultSelectedBody" class="card-body">
        <p class="card-text" [innerHTML]="contactUs.defaultSelectedBody | mdToHtml"></p>
      </div>
    </div>
    <div class="card-body">
      <p class="card-text" [innerHTML]="contactUs.belowBody | mdToHtml"></p>
    </div>
  </div>
</div>
